export const talkItemList = [
  {
    talkTitle: '策定のきっかけ',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: '永田',
        talkContent: (
          <>
            トライアルグループは創業40周年を迎えて、次のステージへ準備を整えています。新たなステージに向けて全員が挑戦できるように、共通言語を定めて理解浸透を図りたいと思ったことがきっかけです。
          </>
        ),
      },
    ],
  },
  {
    talkTitle: '策定のための議論を振り返って',
    talkList: [
      {
        id: '1',
        nameColor: '#3786c7',
        name: '石橋',
        talkContent: (
          <>
            時代と共に「変えるべきもの」と、創業の理念として「変えてはならないもの」があります。
            <br />
            言葉選びもこだわりましたが、「変えるもの」と本質的に「変えてはならないもの」の抽出は、時間をかけて議論しました。
          </>
        ),
      },
    ],
  },
  {
    talkTitle: '言葉に込めた思い',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: '永田',
        talkContent: (
          <>
            それぞれにキーメッセージを込めています。例えばパーパスにある「世界中の誰もが豊かさを享受できる」。
            <br />
            自社だけがメリットを享受するのではなく、私たちが努力をすることで社会に良い影響を及ぼして、ひいては世界に豊かさを創出することがトライアルグループの存在意義であります。
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'こだわりのポイント',
    talkList: [
      {
        id: '1',
        nameColor: '#3786c7',
        name: '石橋',
        talkContent: (
          <>
            「Practical savvy（人の経験知）」という言葉にこだわりました。
            <br />
            トライアルの特徴をビジョンに表現する際、テクノロジーだけでなく、人の「経験知」を大切にしていることをメッセージとして込めました。それを日本語と英語で表現できるように、工夫しました。
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#002D65',
        name: '永田',
        talkContent: (
          <>
            「経験知」は当社の特徴を表している言葉です。「知」という漢字を使っている理由は、人がたくさんの挑戦から得た学びを、会社の成長に繋げることを大切にしてきたからです。
            <br />
            時代に合うテクノロジーを取り入れながら、恐れずに挑戦していくというメッセージを込めています。
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'どう経営に活かしていくか',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: '永田',
        talkContent: (
          <>
            全員がパーパス・ビジョン・バリューの重要性を理解した上で、行動することが重要です。トライアルの店舗が重視するお客様視点に立った価値提案に、テクノロジーが掛け合わさることで、それが実現できると考えています。
            <br />
            流通事業とリテールAI事業はビジネスの中身は違いますが、目的地は同じです。グループの事業が繋がることで、ビジョンの達成やバリューの実現ができます。
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#3786c7',
        name: '石橋',
        talkContent: (
          <>
            多くのお客様に貢献するよう、活かしていきます。
            <br />
            流通事業は日々の現場で起きていることが、未来を創る発想の起点です。全員の「気づき」が未来に繋がっていきます。
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'トライアルらしさとは',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: '永田',
        talkContent: (
          <>
            流通を科学することが、ビジョンにある「テクノロジー」という言葉に凝縮されています。今後、長い時間をかけて私たちが達成していくことを、パーパスやビジョンとしました。
            <br />
            私たちはグローバル視点を持っており、「世界」や「テクノロジー」という単語で、トライアルらしさを表現していきます。
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#3786c7',
        name: '石橋',
        talkContent: (
          <>
            今と未来の両方を同時に動かしていくことが、トライアルらしさの一つです。
            <br />
            店舗で物を流通させるリアルと、データというバーチャルを同時に動かしていることが私たちらしさであり、それをバリューに表現しています。
          </>
        ),
      },
    ],
  },
]
